import React from 'react'; 
import ReactDOM from 'react-dom/client';
import CreateReactClass from "create-react-class";
import {loadpost_pastor} from "./main_02_A_A_A.js";



export function E_Commentsection_output_ID(id){
//contoh
var id_changes = id.concat("_C");
  var box = "id="+id;
//  console.log(box);
 var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
  console.log(this.responseText);
 var array = JSON.parse(this.responseText);
    document.getElementById(id_changes).innerHTML = "";
 E_Commentsection_Selection_engine(id,array);
console.log(array);
    }
  };

  xhttp.open("POST", "./php/c_comment03.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.withCredentials = true;
  xhttp.send(box);
}


export function E_Commentsection_initial_ID(id){
//contoh
var id_changes = id.concat("_C");
  var box = "id="+id;
//  console.log(box);
 var xhttp = new XMLHttpRequest();
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
  console.log(this.responseText);
 var array = JSON.parse(this.responseText);
 document.getElementById(id_changes).innerHTML = "";
 E_Commentsection_Initiale_engine(id,array);
 localStorage.setItem("T_Comment", array[1]);
 console.log(array);
    }
  };

  xhttp.open("POST", "./php/c_comment02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.withCredentials = true;
  xhttp.send(box);

}

export function E_Commentsection_Selection_engine(id,array){


//array.forEach(loadpost);
var size = array[1].length;
//console.log(array)
//console.log("apa lagi");

if (size == 1){
 
  for (var i = 0; i < size; i++) {
    if(array[1][i] != "Anonymous"){
   loadpost_pastor(id,array[0][i],array[1][i]);
 //     loadpost_pastor(id,array[0],array[2][0]);
  }else{
   loadpost(id,array[0][i],array[1][i]); 
 } 
 }    
load_less_button(id);
}else{

for (var i = 0; i < size; i++) {
 if(array[1][i] != "Anonymous"){
      loadpost_pastor(id,array[0][i],array[1][i]);
  }else{
    loadpost(id,array[0][i],array[1][i]); 
 }
 }
load_less_button(id);
}
}


export function E_Commentsection_Initiale_engine(id,array){

//array.forEach(loadpost);
//
var title = array[2];
if (array[0] != null){
  if(title != "Anonymous"){
      loadpost_pastor(id,array[0],array[2][0]);
  }else{
   loadpost(id,array[0],array[2][0]); 

 }
  if (array[1] > 1) {
   load_more_button(id);
 }
}

//to put number of comment
put_comment_id(id,array[1]);
}

var Comment = CreateReactClass({
  displayName: "Comment",

  getDefaultProps: function getDefaultProps() {
    return { name: "Douglas Adams" };
  },
  render: function render() {
    return React.createElement(
      "div",
      { className: "single-comment" },
      React.createElement("div",{className: "Container_Comment_image"},
      React.createElement("img",{style: {backgroundImage: this.props.url}})),
      React.createElement(
        "div",
        { className: "single-container" },
        React.createElement(
          "p",
          {className:"single-container_name"},
          this.props.name
        ),
        React.createElement(
          "p",
          {className:"single-container_p"},
          this.props.children
        )
      ),
      React.createElement(
        "div",
        { className: "buttons" },
        React.createElement(Action, { text: "Like!" }),
        React.createElement(Action, { text: "Respond" }),
        React.createElement(Hour, { time: this.props.time })
      )
    );
  }
});




export function loadpost(id,I_comment,people) {

var mains = document.createElement("DIV");
mains.id = "container_app_2";
mains.style.animation = "fadein 0.5s ease-in";
//contoh

console.log("apa la lagi"+id);
var id = id.concat("_C");
 document.getElementById(id).appendChild(mains);
//document.body.insertBefore(mains,document.getElementById(id).nextSibling);
//localStorage.setItem("id",id);
var name = people.replaceAll("_", " ");

var P_recursive = CreateReactClass({
  
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
          Comment,
          { name: name, time: 3, className:id,url: "url(./profile/assets/php/"+people+"_front.png)" },
          I_comment
        );
  }
});

var container = React.createElement(
  "div",
  null,
  React.createElement(P_recursive, null)
  )

ReactDOM.render(container, mains);

}


export function load_more_button(id){
 
var mains = document.createElement("DIV");
mains.id = "container_app_2";
//contoh
var id_changes = id.concat("_C");
document.getElementById(id_changes).appendChild(mains);

var f_load_more = CreateReactClass({
  
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
     return {
      id: id
    };
  },
  _tekan: function _tekan() {

this.F_Fadding_1();
setTimeout(this.F_Fadding_2, 900);
  },

  F_Fadding_1: function F_Fadding_1() {
//name: Display comment technique
var x = document.getElementById(id_changes).querySelectorAll("#container_app_2");
  for (var i = 0; i < x.length; i++) {
   x[i].style.animation = "fade ease 1s";
x[i].id = "container_app_1";
  }
  },

  F_Fadding_2: function F_Fadding_2() {
    //document.getElementById(id_changes).

E_Commentsection_output_ID(this.props.id); 
  },

  render: function render() {

  return React.createElement("button", { id: "hai", onClick: this._tekan ,className:"B_button_load_more",
        color:"#f194ff"},React.createElement("p",null,"Load More"))
   }
});

var container = React.createElement(
  "div",
  {className:"div_b_button_load_more", id: "container_app_2"},
  React.createElement(f_load_more, null)
  )

ReactDOM.render(container, mains);
}


export function load_less_button(id){
 
var mains = document.createElement("DIV");
mains.id = "container_app_2";

var id_changes = id.concat("_C");
document.getElementById(id_changes).appendChild(mains);

var f_load_less = CreateReactClass({
  
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
     return {
      id: id
    };
  },

  _tekan: function _tekan() {

// This Took me another 3 hours just to finihsed this doing up
  this.F_Fadding_1();
  setTimeout(this.F_Fadding_2, 900); 
  },
  F_Fadding_1: function F_Fadding_1() {
//name: Display comment technique
  var x = document.getElementById(id_changes).querySelectorAll("#container_app_2");
  for (var i = 0; i < x.length; i++) {
   x[i].style.animation = "fade ease 1s";
  x[i].id = "container_app_1";
  }
  },
  F_Fadding_2: function F_Fadding_2() {
   E_Commentsection_initial_ID(this.props.id);
  },
  render: function render() {

  return React.createElement("button", { id: "hai", onClick: this._tekan ,className:"B_button_load_more",
        color:"#f194ff"},React.createElement("p",null,"Load Less"))
   }
});

var container = React.createElement(
  "div",
  {className:"div_b_button_load_more"},
  React.createElement(f_load_less, null)
  )

ReactDOM.render(container, mains);
}


export function load_comment_post(id,I_comment,people) {

var mains = document.createElement("DIV");
mains.id = "container_app_2";
mains.style.animation = "fadein 0.5s ease-in";
//contoh
var id = id.concat("_C");

var x = document.getElementById(id).querySelectorAll("#container_app_2");

//The purpose is simple, so that adding the comment would be much more different and not too much of you know adding differently..7/6/2021
if(x.length < 2){
document.getElementById(id).appendChild(mains);

}else{
  //document.getElementById(id).appendChild(mains);
  
var y = document.getElementById(id).lastChild;
var z = y.lastChild;

if (z.id == "container_app_2") {
 // var x = document.getElementById(id).lastChild;
document.getElementById(id).insertBefore(mains,y);
}else{
document.getElementById(id).appendChild(mains);
}

}


var name = people.replaceAll("_"," ");

var P_recursive = CreateReactClass({
  
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
          Comment,
          { name: name, time: 3,url: "url(./profile/assets/php/"+people+"_front.png)"},
          I_comment
        );
  }
});

var container = React.createElement(
  "div",
  null,
  React.createElement(P_recursive, null)
  )

ReactDOM.render(container, mains);

}

function put_comment_id(id,number){
  var i = id+"_C2";
  document.getElementById(i).innerHTML = number;
}






export var Action = CreateReactClass({
  displayName: "Action",
    getDefaultProps: function getDefaultProps() {
    return {
      number : 0
    };
  },  
  //untuk tambah likes function
_handleKeyPress: function _handleKeyPress(e) {

//to prevent doublereentering of likes.
if (this.props.number == 0) {
//future problem, cause it take another round of clips to get the array here.
var bool = JSON.parse(localStorage.getItem("container"));
bool[1] = bool[1].substring(0, bool[1].length-1);
var num = bool[1].split(",");
var id = bool[0].concat(num.length -1);
  var box = "post_id="+id;
  console.log(box);
  var xhttp = new XMLHttpRequest();
  
  xhttp.onreadystatechange = function() {
    if (this.readyState == 4 && this.status == 200) {
      console.log(this.responseText);
      //container = this.responseText;

    }
  };

  xhttp.open("POST", "php/keyin02.php", true);
  xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
  xhttp.withCredentials = true;
  xhttp.send(box);

  document.getElementById(id).innerHTML = parseInt(document.getElementById(id).innerHTML) + 1;
  this.props.number = 1;
}
  },
  render: function render() {
    return React.createElement(
      "p",
      { className: "action-button" ,onClick: this._handleKeyPress},
      this.props.text
    );
  }
});


export var Hour = CreateReactClass({
  displayName: "Hour",

  getDefaultProps: function getDefaultProps() {
    return {
      time: 42
    };
  },

  render: function render() {
    return React.createElement(
      "p",
      null,
      this.props.time,
      " h"
    );
  }
});


